import {Component, forwardRef, OnChanges, SimpleChanges, Output, EventEmitter, AfterContentChecked, Input} from '@angular/core';
import { NG_VALUE_ACCESSOR, FormGroup, FormControl } from '@angular/forms';
import { InputGridModel } from '../input-grid.model';
import { DynamicFormControlModel } from '@ng-dynamic-forms/core';
import { COMPONENT_MODE } from '../../workflow-components.models';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';
import { Model_WorkflowComponent } from 'src/app/app.models';
import {v4 as uuidv4} from 'uuid';
import { ABW_MAT_DATATABLE_VIEWMODE } from 'src/app/shared/abw-mat-datatable/abw-mat-datatable.component';
import { ApplyFilterDatasource } from '../../datasource-picker/datasource.helper';

@Component({
    selector: 'abw-input-grid-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => InputGridFormComponent),
        multi: true
      }
    ],
    templateUrl: './input-grid-form.component.html',
    styleUrls: ['./input-grid-form.component.scss']
})
export class InputGridFormComponent extends AbstractWorkflowFormComponent<InputGridModel, any[]> implements OnChanges, AfterContentChecked {
    @Output() onEdit = new EventEmitter();
    @Output() change = new EventEmitter(); 
	@Input() isEditableRows = false;
	@Input() isDeletableRows = false;
    totalRows = 1;
    rowsFormsGroup: FormGroup[] = [];
    rowsFormsModel: DynamicFormControlModel[][] = [];
    forceRefresh = false;
    basedComponents: Model_WorkflowComponent[] = [];
    rowsComponents: any[] = [];
    datasourceMappingMode = 1;
    ABW_MAT_DATATABLE_VIEWMODE = ABW_MAT_DATATABLE_VIEWMODE;

    async ngOnInit() {
        super.ngOnInit();
    }

    async ngOnChanges(changes: SimpleChanges): Promise<void> {
        if (!!changes.model && !!changes.model.currentValue && !!changes.model.currentValue.gridColumns) {
            if (changes.model.currentValue.value !== null) {
                this.totalRows = changes.model.currentValue.value.length;
            }
            this.basedComponents = await this._workflowComponentsService.doGetBaseWorkflowComponents().toPromise();
            this.rowsComponents = this._getRowComponents();

            const workflowComponent = this.model.additional;
            if (workflowComponent.HAS_DATASOURCE === true && !!workflowComponent.UIC_PARAMS && !!workflowComponent.UIC_PARAMS.DATASOURCE && !!workflowComponent.UIC_PARAMS.DATASOURCE.DATASOURCE_DATAS) {
                if (!!workflowComponent.UIC_PARAMS.DATASOURCE.DATASOURCE_DS_FILTERS) {
                    workflowComponent.UIC_PARAMS.DATASOURCE.DATASOURCE_FILTERED_DATAS = workflowComponent.UIC_PARAMS.DATASOURCE.DATASOURCE_DATAS;
                    workflowComponent.UIC_PARAMS.DATASOURCE.DATASOURCE_DS_FILTERS.forEach(filter => {
                        const workflowComponent = (this.model as any).additional as Model_WorkflowComponent;
                        const formGroupId = workflowComponent.FORM_ID || '_FORM_';
                        const workflowValues = this._workflowComponentsService.context;

                        // TODO: apply filter based on TYPE_DEFAULT_VALUE 
                        const filterValue = filter.TYPE_DEFAULT_VALUE == 1 ? filter.DEFAULT_VALUE  : (!!workflowValues && !!workflowValues.formValues && !!workflowValues.formValues[formGroupId] && workflowValues.formValues[formGroupId][filter.DEFAULT_VALUE] !== undefined ? workflowValues.formValues[formGroupId][filter.DEFAULT_VALUE] : null);

                        workflowComponent.UIC_PARAMS.DATASOURCE.DATASOURCE_FILTERED_DATAS = workflowComponent.UIC_PARAMS.DATASOURCE.DATASOURCE_FILTERED_DATAS.filter(d => ApplyFilterDatasource(filter, filterValue, d)); 
                    });
                }
                if (workflowComponent.GRID_COLUMNS_DATASOURCE_MAPPING_MODE == 2) {
                    this.gridDatasourceDatas = { 
                        mPagination: { 
                            mDatas: workflowComponent.UIC_PARAMS.DATASOURCE.DATASOURCE_DATAS, 
                            mCountTotal: workflowComponent.UIC_PARAMS.DATASOURCE.DATASOURCE_COUNT_TOTAL, 
                            mPageNumber: workflowComponent.UIC_PARAMS.DATASOURCE.DATASOURCE_PAGE_NUMBER, 
                            mTotalPages: workflowComponent.UIC_PARAMS.DATASOURCE.DATASOURCE_TOTAL_PAGES, 
                            mPageSize: workflowComponent.UIC_PARAMS.DATASOURCE.DATASOURCE_PAGE_SIZE,
                        },
                        mAbsColumns: workflowComponent.UIC_PARAMS.DATASOURCE.DATASOURCE_COLUMNS,
                    };
                } else {
                    this.datasourceDatas = workflowComponent.UIC_PARAMS.DATASOURCE.DATASOURCE_DATAS;
                    this.datasourceFilteredDatas = workflowComponent.UIC_PARAMS.DATASOURCE.DATASOURCE_FILTERED_DATAS;
                    this.totalRows = workflowComponent.UIC_PARAMS.DATASOURCE.DATASOURCE_FILTERED_DATAS.length;
                }
                this.datasourceMappingMode = workflowComponent.GRID_COLUMNS_DATASOURCE_MAPPING_MODE;
            }

            await this._buildGridForm(this.totalRows); 
        }
    }

    ngAfterContentChecked() {
    }

	onGridFormValueChanged(_rowIndex: number, _event: { control: FormControl, group: FormGroup, model: any }) {
		const workflowComponent = (_event.model as any).additional as Model_WorkflowComponent;
        if (!!this.value[_rowIndex]) {
            this.value[_rowIndex][_event.model.id] = _event.control.value;
        }
        this.onValueChanged(this.value, false); 
        //this.onValueChanged(this.value); 
        this._workflowComponentsService.gridComponentsValuesChanged$.next({ 
            sender: workflowComponent, 
            formId: workflowComponent.FORM_ID, 
            workflow: this._workflowComponentsService.context.workflow,
            gridValue: this.value, 
            rowValue: this.value[_rowIndex],
            rowModels: this.rowsFormsModel[_rowIndex],
            rowIndex: _rowIndex, 
        });
	}

    async setRows(_rows: any) {
        this.totalRows = _rows;
        await this._buildGridForm(this.totalRows);
    }

    getRowValues() {
        return this.value;
    }

    async setRowValues(_rowIndex: number, _rowValues: any) {
        this.value[_rowIndex] = _rowValues;
        Object.keys(this.value).filter(k => this.value[k].INDEX === undefined).forEach((k, i) => this.value[k].INDEX = i + 1);
        this.value = this.value.sort((a, b) => {
            const index1 = parseInt(a.INDEX.toString());
            const index2 = parseInt(b.INDEX.toString());
            return index1 != index2 ? index1 - index2 : (b.INDEX == _rowValues.ID ? 1 : -1);
        });
        Object.keys(this.value).forEach((k, i) => this.value[k].INDEX = i + 1);
        this.model.value = this.value;
        await this._buildGridForm(this.totalRows); 
    }

    async addRow() {
        const formGroupId = uuidv4();
        const totalRows = this.totalRows + 1;
        const gridFormGroupId = this.model.workflowComponentBuilderOptions?.formId;
        const rowFormModel = await this._workflowComponentsService.doBuildWorkflowModel(this.rowsComponents, { COMPONENTS_MODE: COMPONENT_MODE.EXECUTION, formId: formGroupId, gridFormId: gridFormGroupId, isGridComponent: true });
        const rowFormGroup = await this._workflowComponentsService.doBuildWorkflowFormGroup(rowFormModel);
        if (rowFormGroup.controls.INDEX !== undefined) {
            rowFormGroup.controls.INDEX.patchValue(totalRows);
        }
        this.rowsFormsModel.push(rowFormModel);
        this.rowsFormsGroup.push(rowFormGroup);
        this._updateContext(formGroupId, rowFormGroup, rowFormModel);
        this.value.push(rowFormGroup.value);
        //this.change.emit(this.value);
        this.onValueChanged(this.value);
        this.totalRows = totalRows;
    }

    editRow(indexArray: number) {
        this.onEdit.emit({ index: indexArray, data: this.value[indexArray] });
    }

    removeRow(rowIndex: number) {
        this.rowsFormsModel.splice(rowIndex, 1);
        this.rowsFormsGroup.splice(rowIndex, 1);
        this.value.splice(rowIndex, 1);
        this.change.emit(this.value);
        this.totalRows -= 1;
    }

    private _getRowComponents() {
        const rowComponents = [];
        for (var j = 0; j < this.model.gridColumns.length; j++) {
            const basedComponent = this.basedComponents.find(c => c.CODE == this.model.gridColumns[j].CODE);
            if (!!basedComponent) {
                const component = JSON.parse(JSON.stringify(basedComponent)); 
                component.ID = this.model.gridColumns[j].ID;
                component.INDEX = j;
                component.CODE = this.model.gridColumns[j].CODE;
                component.LABEL = this.model.gridColumns[j].LABEL;
                component.IS_VISIBLE = this.model.gridColumns[j].IS_VISIBLE !== undefined ? this.model.gridColumns[j].IS_VISIBLE : true;
                component.IS_READONLY = this.model.gridColumns[j].IS_READONLY == true;
                component.NUMBER_FORMAT = this.model.gridColumns[j].NUMBER_FORMAT;
                component.UIC_PARAMS = this.model.gridColumns[j].UIC_PARAMS;
                component.TYPE_DEFAULT_VALUE = this.model.gridColumns[j].TYPE_DEFAULT_VALUE;
                component.TYPE_DEFAULT_VALUE_FUNCTION_ID = this.model.gridColumns[j].TYPE_DEFAULT_VALUE_FUNCTION_ID;
                component.DEFAULT_VALUE = this.model.gridColumns[j].DEFAULT_VALUE;
                component.DEFAULT_VALUE_EXPRESSION = this.model.gridColumns[j].DEFAULT_VALUE_EXPRESSION;
                component.VALUE_COLUMN_NAME = this.model.gridColumns[j].VALUE_COLUMN_NAME;
                component.DISPLAY_COLUMN_NAME = this.model.gridColumns[j].DISPLAY_COLUMN_NAME;
                component.DEFAULT_VALUE_WORKFLOW_COMPONENT_ID = this.model.gridColumns[j].DEFAULT_VALUE_WORKFLOW_COMPONENT_ID;
                component.DEFAULT_VALUE_WORKFLOW_COMPONENT_PROPERTY = this.model.gridColumns[j].DEFAULT_VALUE_WORKFLOW_COMPONENT_PROPERTY;
                component.NUM_DATASOURCE = this.model.gridColumns[j].NUM_DATASOURCE;
                component.CONDITIONS_ENABLED = this.model.gridColumns[j].CONDITIONS_ENABLED;
                component.PROPERTIES.filter(p => this.model.gridColumns[j][p.ID] !== undefined).forEach(p => {
                    p.DEFAULT_VALUE = this.model.gridColumns[j][p.ID];
                });
                component.PARENT_GRID_INPUT_ID = this.model.id;
                rowComponents.push(component);
            }
        }
        return rowComponents;
    }

    private async _buildGridForm(_totalRows: number) {
        const workflowComponent = this.model.additional;
        const rowsFormsModel = [];
        const rowsFormsGroup = [];
        const rowsFormValues = []; 
        const gridFormGroupId = this.model.workflowComponentBuilderOptions?.formId;
        this.rowsComponents.forEach(rowComponent => rowComponent.IS_READONLY = rowComponent.IS_READONLY || this.model.readOnly);
        for (var i = 0; i < _totalRows; i++) {
            const formGroupId = uuidv4();
            const rowFormModel = await this._workflowComponentsService.doBuildWorkflowModel(this.rowsComponents, { COMPONENTS_MODE: COMPONENT_MODE.EXECUTION, formId: formGroupId, gridFormId: gridFormGroupId, isGridComponent: true });
            const rowFormGroup = await this._workflowComponentsService.doBuildWorkflowFormGroup(rowFormModel);

            if (workflowComponent.HAS_DATASOURCE === true && !!workflowComponent.GRID_COLUMNS_DATASOURCE_MAPPING && !!this.datasourceFilteredDatas && this.datasourceFilteredDatas.length > i) {
                workflowComponent.GRID_COLUMNS_DATASOURCE_MAPPING.forEach(c => {
                    if (!!rowFormGroup.controls[c.GRID_COLUMN] && !!this.datasourceFilteredDatas[i][c.DATASOURCE_COLUMN]) {
                        rowFormGroup.controls[c.GRID_COLUMN].patchValue(this.datasourceFilteredDatas[i][c.DATASOURCE_COLUMN]);
                    }
                });
            }
            if (!!this.model.value && this.model.value[i] !== undefined) {
                rowFormGroup.patchValue(this.model.value[i]);
            }

            rowsFormsModel.push(rowFormModel);
            rowsFormsGroup.push(rowFormGroup);
            rowsFormValues.push(this.model.value != null && !!this.model.value[i] ? this.model.value[i] : rowFormGroup.value);
            this._updateContext(formGroupId, rowFormGroup, rowFormModel);
        } 
        this.rowsFormsModel = rowsFormsModel;
        this.rowsFormsGroup = rowsFormsGroup;
        this.value = rowsFormValues;
        this.change.emit(this.value);
        try { this._cdf.detectChanges(); } catch(e) {}
        this._workflowComponentsService.formService.detectChanges();
    }

    private _updateContext(_formGroupId: string, _formGroup: FormGroup, _formModel: any) {
        const context = this._workflowComponentsService.context;
        if (context.formValues === undefined) { context.formValues = {}; }
        if (context.formModels === undefined) { context.formModels = {}; }
        if (context.formValues[_formGroupId] === undefined) { context.formValues[_formGroupId] = {}; }
        if (context.formModels[_formGroupId] === undefined) { context.formModels[_formGroupId] = []; }

        context.formValues[_formGroupId] = Object.assign(context.formValues[_formGroupId], _formGroup.value);
        context.formModels[_formGroupId] = context.formModels[_formGroupId].concat(_formModel);
        this._workflowComponentsService.workflowValuesChanged$.next(context);
    }

    gridDatasourceMappingSelection() {
        const workflowComponent = this.model.additional;
        
        const selection = this.rowsFormsGroup.map(rowFormGroup => {
            const selectionItem: any = {};
            workflowComponent.GRID_COLUMNS_DATASOURCE_MAPPING.forEach(c => {
                if (!!rowFormGroup.contains(c.GRID_COLUMN)) {
                    selectionItem[c.DATASOURCE_COLUMN] = rowFormGroup.controls[c.GRID_COLUMN].value;
                }
            });
            return selectionItem;
        });
        return selection;
    }

    gridDatasourceMappingPrimaryKey() {
        const workflowComponent = this.model.additional;
        return workflowComponent.GRID_COLUMNS_DATASOURCE_MAPPING.find(c => c.PRIMARY_KEY === true);
    }

    onSelection(selection: any[]) {
        const workflowComponent = this.model.additional;
        const pkColumn = workflowComponent.GRID_COLUMNS_DATASOURCE_MAPPING.find(c => c.PRIMARY_KEY === true);
        const rowsDatas = this.rowsFormsGroup.map(r => r.value);
        if (!!pkColumn) {
            const pkDatasourceValues = rowsDatas.filter(row => !!row[pkColumn.GRID_COLUMN]).map(row => row[pkColumn.GRID_COLUMN]);
            selection = selection.filter(row => pkDatasourceValues.lastIndexOf(row[pkColumn.DATASOURCE_COLUMN]) == -1);
        }
        if (selection.length > 0) {
            this.datasourceFilteredDatas = rowsDatas.concat(selection);
            this.totalRows = this.datasourceFilteredDatas.length;
            this.model.value = this.value;
            this._buildGridForm(this.totalRows);
        }
    }
}